<div style="display:flex; flex-direction: column;text-align: center;margin-top: 33vh;" *ngIf="loader">
  <spinner [status]="'Checking'"></spinner>
  <span style="color: #043c66; font-size: 20px;">Please wait for the system check</span>
</div>
<div>
  
</div>
